module.exports = __webpack_public_path__ + "img/logo-huawei.31e59814.png";